import {
  ADD_LANGUAGES,
  ADD_CATEGORIES,
  ADD_COST_CENTERS,
  ADD_SITE_SEGMENTS,
  ADD_NATIONAL_EMERGENCY,
} from "../actions/master.action";
import {
  CostCenterModel,
  AssetCategoryModel,
  CountryEmergencyContacts,
} from "../models/asset.model";
import { createReducer, on } from "@ngrx/store";
import { LanguageModel } from "../models/language.model";
import { SiteSegmentModel } from "../models/siteSegment.model";

const INITIAL_STATE_COST_CENTERS: CostCenterModel[] = [];
const INITIAL_STATE_LANGUAGES: LanguageModel[] = [];
const INITIAL_STATE_CATEGORIES: AssetCategoryModel[] = [];
const INITIAL_STATE_NATIONAL_EMERGENCY: CountryEmergencyContacts[] = [];
const INITIAL_STATE_SITE_SEGMENTS: SiteSegmentModel[] = [];

export const CategoriesReducer = createReducer(
  INITIAL_STATE_CATEGORIES,
  on(ADD_CATEGORIES, (_, { categories }) => categories),
);

export const CostCentersReducer = createReducer(
  INITIAL_STATE_COST_CENTERS,
  on(ADD_COST_CENTERS, (_, { costCenters }) => costCenters),
);

export const LanguagesReducer = createReducer(
  INITIAL_STATE_LANGUAGES,
  on(ADD_LANGUAGES, (_, { languages }) => languages),
);

export const NationalEmergencyReducer = createReducer(
  INITIAL_STATE_NATIONAL_EMERGENCY,
  on(
    ADD_NATIONAL_EMERGENCY,
    (_, { nationalEmergencies }) => nationalEmergencies,
  ),
);

export const SiteSegmentsReducer = createReducer(
  INITIAL_STATE_SITE_SEGMENTS,
  on(ADD_SITE_SEGMENTS, (_, { siteSegments }) => siteSegments),
);